import React, { memo } from 'react';
import { Stack, Flex, Image, Box, Text } from '@chakra-ui/react';

import aiIcon from '@/assets/icon/ai-icon.svg';
import { InterviewAnalysisResult, AlertsAndFollowUpQuestion } from '@/types/AnalysisResult';
import RequirementsMatchSection from '../Candidate/components/RequirementsMatchSection';
import FollowUpItemsSection from '../Candidate/components/FollowUpItemsSection';

interface InterviewSummarySectionProps {
  analysisResult: InterviewAnalysisResult;
  followUpQuestions: AlertsAndFollowUpQuestion[];
  onUpdateItem: (index: number, item: AlertsAndFollowUpQuestion | null) => Promise<boolean>;
  followUpItemsRef: React.RefObject<HTMLDivElement | null>;
}

const InterviewSummarySection = memo(
  ({
    analysisResult,
    followUpQuestions,
    onUpdateItem,
    followUpItemsRef
  }: InterviewSummarySectionProps) => {
    return (
      <Stack gap="12px">
        <Stack>
          <Flex mb="12px">
            <Image src={aiIcon} w="20px" h="20px" alt="AI Overview" />
            <Box color="neutrals.900" fontSize="18px" fontWeight="semibold" ml="8px">
              AI Overview
            </Box>
          </Flex>
          <Text
            id="ai-overview"
            fontSize="16px"
            color="neutrals.700"
            p={0}
            whiteSpace="pre-wrap"
            mb="12px"
          >
            {analysisResult.overview}
          </Text>
        </Stack>
        <RequirementsMatchSection analysisResult={analysisResult} />
        <FollowUpItemsSection
          followUpQuestions={followUpQuestions}
          onUpdateItem={onUpdateItem}
          followUpItemsRef={followUpItemsRef}
        />
      </Stack>
    );
  }
);

InterviewSummarySection.displayName = 'InterviewSummarySection';

export default InterviewSummarySection;
